export class TagsDonneesManquantes {
  public static FEL_CONTRIB = 'FEL-CONTRIB';
  public static FEL_GEST = 'FEL-GEST';
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/common/constants/TagsDonneesManquantes.ts